import { PageState } from 'models/PageState';

export const selectPhoneNumber = (state: PageState) => state.header.contact.phonenumber;

export const selectOpeningHours = (state: PageState) => state.header.contactSection?.title;
